import { render, staticRenderFns } from "./DocumentHeadersGroup.vue?vue&type=template&id=653e2236&scoped=true&"
import script from "./DocumentHeadersGroup.vue?vue&type=script&lang=js&"
export * from "./DocumentHeadersGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653e2236",
  null
  
)

export default component.exports